"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMarginLeft = void 0;

var _toolbar = require("../constants/toolbar");

var getMarginLeft = function getMarginLeft(previousType) {
  if (previousType === null) {
    return _toolbar.ToolbarControlMargins.ZERO;
  }

  if (previousType === _toolbar.ToolbarControlTypes.BUTTON) {
    return _toolbar.ToolbarControlMargins.BUTTON;
  }

  return _toolbar.ToolbarControlMargins.DEFAULT;
};

exports.getMarginLeft = getMarginLeft;